import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import EmojiPicker from "emoji-picker-react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import "boxicons";
import { CommentInsert, GetComment } from "../../apis/api/TimelineApi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Lodderr from "../../components/Lodder/Lodder";

const CommentModal = ({ show, handleClose, data }) => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const userid = Cookies.get("userID");
  const companyid = Cookies.get("company_id");
  const access = JSON.parse(Cookies.get("access"));

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    const fetchComments = async () => {
      if (data?.company_post_id) {
        await dispatch(GetComment({ postId: data.company_post_id }));
      }
    };

    fetchComments();

    const interval = setInterval(fetchComments, 5000);

    return () => clearInterval(interval);
  }, [dispatch, data?.company_post_id]);

  const onSubmit = async (formData) => {
    const payload = new FormData();
    payload.append("comment", formData.comment);
    payload.append("member_id", userid);
    payload.append("company_id", companyid);
    payload.append("company_post_id", data?.company_post_id);

    const response = await dispatch(CommentInsert(payload));
    if (response?.payload?.status == "success") {
      await dispatch(GetComment({ postId: data?.company_post_id }));
      toast.success("comment inserted succesfully ...");
    } else {
      toast.error("error while inserting comment ...");
    }

    reset();
    setShowEmojiPicker(false);
  };

  const { getcomments, loading } = useSelector((state) => state.TimelineSlice);

  const addEmoji = (emojiObject) => {
    const currentComment = getValues("comment") || "";
    const updatedComment = currentComment + emojiObject.emoji;
    setValue("comment", updatedComment);
    setShowEmojiPicker(false);
  };

  const renderMedia = () => {
    if (!data?.file_url || !data?.file_extension) return null;
    const ext = data.file_extension.toLowerCase();

    if (ext === "image") {
      return (
        <>
          <img
            src={data.file_url}
            alt="Post media"
            className="img-fluid rounded shadow"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                process.env.PUBLIC_URL + "/company-logo-design.jpg";
            }}
          />

          <p className="text-muted small  p-3 bg-white">
            {data?.text || "No description"}
          </p>
        </>
      );
    }

    if (ext === "video") {
      return (
        <video controls className="w-100 rounded shadow">
          <source src={data.file_url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (ext === "audio") {
      return (
        <audio controls className="w-100 mt-3">
          <source src={data.file_url} type="audio/mpeg" />
          Your browser does not support the audio tag.
        </audio>
      );
    }

    return null;
  };

  const hasMedia = data?.file_url && data?.file_extension;

  return (
    <>
      {loading && <Lodderr />}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Comments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={handleSubmit(onSubmit)}
            className="p-3 border rounded shadow bg-light"
          >
            <div className="d-flex flex-row gap-3" style={{ height: "400px" }}>
              {hasMedia && (
                <div className="col-md-6 h-100">
                  <div className="border p-2 rounded bg-white h-100">
                    {renderMedia()}
                  </div>
                </div>
              )}

              <div className={hasMedia ? "col-md-6 h-100" : "col-12 h-100"}>
                <div
                  className="border p-2 rounded bg-white h-100"
                  style={{ overflowY: "auto" }}
                >
                  {getcomments?.data?.map((item, index) => (
                    <div
                      key={index}
                      className="border p-2 rounded bg-light mb-2"
                    >
                      <div className="d-flex align-items-center mb-1">
                        <img
                          src={
                            item.member_logo ||
                            process.env.PUBLIC_URL + "/dummy-profile.png"
                          }
                          alt="Profile"
                          width="32"
                          height="32"
                          className="rounded-circle me-2"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              process.env.PUBLIC_URL + "/dummy-profile.png";
                          }}
                        />

                        <strong>{item.member_name}</strong>
                      </div>
                      <p className="text-muted mb-1">{item.comment}</p>
                      <div className="text-secondary small">
                        {new Date(item.created_at * 1000).toLocaleString()}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {
              (access.comment_feed && access.comment_feed === "1") && 
              <div className="mt-3 position-relative">
                <Form.Group className="d-flex">
                  <div className="w-75">
                    <Form.Control
                      type="text"
                      placeholder="Write a comment..."
                      {...register("comment", { required: true })}
                    />
                  </div>

                  <div className="ms-2 mt-1">
                    <Button
                      variant="primary"
                      className="btn-sm me-1"
                      onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    >
                      <i className="bx bx-smile"></i>
                    </Button>
                    <Button type="submit" variant="primary" className="btn-sm">
                      <i className="bx bx-paper-plane"></i> Post
                    </Button>
                  </div>
                </Form.Group>

                {showEmojiPicker && (
                  <div
                    className="position-absolute"
                    style={{ bottom: "50px", right: "20px", zIndex: 10 }}
                  >
                    <EmojiPicker onEmojiClick={addEmoji} />
                  </div>
                )}
                {errors.comment && (
                  <p className="text-danger small mt-1">Comment is required.</p>
                )}
              </div>
            }
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CommentModal;
